export enum FORM_FIELD {
  CAMPAIGN = 'campaign',
  CLIENT = 'client',
  CAMPAIGN_DATES = 'campaignDates',
  SCHEDULE_DATE = 'scheduleDate',
  TOTAL_BUDGET = 'totalBudget',
  AGENCY_DISCOUNT = 'agencyDiscount',
  CURRENCY = 'currency'
}

/** Default agency discount rate (%) applied to brand-new media plans only. */
export const DEFAULT_AGENCY_DISCOUNT_PERCENT = 15;
